import { BaseWebComponentRepository } from '../../framework/BaseWebComponentRepository';
import { TargetsDataProviderFactory } from '../factory/TargetsDataProviderFactory';
import { ConsoleRequestSettings, GetNodeChildrenRequest, GetNodeChildrenResponse, GetRootRequest, Node } from '../type';
import { TargetsBaseDataProvider } from '../dataProvider/TargetsBaseDataProvider';

export class TargetsRepository extends BaseWebComponentRepository {
  public dataProviderFactory: TargetsDataProviderFactory;
  public dataProvider: TargetsBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new TargetsDataProviderFactory(),
    });
  }

  public async getRootNode(payload: GetRootRequest, settings: ConsoleRequestSettings): Promise<Node> {
    return this.dataProvider.getRootNode(payload, settings);
  }

  public async getChildNodes(
    payload: GetNodeChildrenRequest,
    settings: ConsoleRequestSettings
  ): Promise<GetNodeChildrenResponse> {
    return this.dataProvider.getChildNodes(payload, settings);
  }

  public getViewType(type: number): number {
    return this.dataProvider.getViewType(type);
  }

  public isLeafNode(node: Node, userMode: boolean, showOnlyCompanies: boolean, rootNodeId: string): boolean {
    return this.dataProvider.isLeafNode(node, userMode, showOnlyCompanies, rootNodeId);
  }
}
